import { motion } from "framer-motion";
import powerQuoteBg from "@/assets/power-quote-blue-bg.png";

const PowerQuote = () => {
  return <section className="py-24 md:py-32 relative overflow-hidden" style={{ backgroundColor: "#0a1628" }}>
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={powerQuoteBg} alt="" className="w-full h-full object-cover opacity-40" />
      </div>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#030712]/60 via-[#0a1628]/40 to-[#030712]/60" />
      
      <div className="container px-4 relative z-10">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center">
          <p className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            "El mercado no puede entrar a tu empresa y conocer todo lo que sabés, hacés y construís.{" "}
            <span className="text-blue-light">Lo interpreta a través de señales y experiencias.</span>{" "}
            ¿Qué señales está emitiendo hoy tu marca sin darse cuenta?"
          </p>
          
        </motion.div>
      </div>
    </section>;
};
export default PowerQuote;